import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ErrorNetworkComponent } from '../components/error-network/error-network.component';
import { HeaderComponent } from '../components/header/header.component';
import { HttpErrorModalComponent } from '../components/http-error-modal/http-error-modal.component';
import { MenuComponent } from '../components/menu/menu.component';
import { ModalComponent } from '../components/modal/modal.component';
import { PopoverComponent } from '../components/popover/popover.component';
import { LoginPage } from '../pages/auth/login/login.page';
import { NetworkCheckPage } from '../pages/auth/network-check/network-check.page';
import { TenantSelectPage } from '../pages/auth/tenant-select/tenant-select.page';
import { GoPage } from '../pages/go/go.page';
import { PrintJobsPage } from '../pages/print-jobs/print-jobs.page';
import { PrinterListPage } from '../pages/printer-list/printer-list.page';
import { RegisterNfcTagPage } from '../pages/register-nfc-tag/register-nfc-tag.page';
import { ReleaseHistoryPage } from '../pages/release-history/release-history.page';
import { RouterModule } from '@angular/router';


@NgModule({
  declarations: [
    // ErrorNetworkComponent,
    HeaderComponent,
    // HttpErrorModalComponent,
    // MenuComponent,
    // ModalComponent,
    // PopoverComponent,
    // LoginPage,
    // NetworkCheckPage,
    // TenantSelectPage,
    // GoPage,
    // PrintJobsPage,
    // PrinterListPage,
    // RegisterNfcTagPage,
    // ReleaseHistoryPage
  ],
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    HttpClientModule,
    TranslateModule
  ],
  exports: [
    FormsModule,
    HttpClientModule,
    IonicModule,
    ReactiveFormsModule,
    TranslateModule,
    // ErrorNetworkComponent,
    HeaderComponent,
    // HttpErrorModalComponent,
    // MenuComponent,
    // ModalComponent,
    // PopoverComponent,
    // LoginPage,
    // NetworkCheckPage,
    // TenantSelectPage,
    // GoPage,
    // PrintJobsPage,
    // PrinterListPage,
    // RegisterNfcTagPage,
    // ReleaseHistoryPage
  ]
})
export class SharedModule { }
